export enum actionTypes {
    PAGE_DATA_SET = 'PAGE:DATA:SET',
    PAGE_RENDERED_TOGGLE = 'PAGE:RENDERED:TOGGLE',
    PAGE_RENDERING_TOGGLE = 'PAGE:RENDERING:TOGGLE',
    PAGE_POPUP_BG_PAGE_PATH_SET = 'PAGE:POPUP_BG_PAGE_PATH:SET',
    PAGE_DYNAMIC_PAGE_PATH_SET = 'PAGE:DYNAMIC_PAGE_PATH:SET'
}
